import React, { FC, useEffect, useState } from 'react';
import { Backdrop, Box, Typography } from '@mui/material';
import Lottie from 'react-lottie';
import AIAnimation from '../../assets/lottie/ai-v2.json';

interface AnimatedBackdropProps {
  title: string;
  subtitle: string;
}

const AnimatedBackdrop: FC<AnimatedBackdropProps> = ({
  title,
  subtitle,
}) => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const intervalId = setInterval(() => {
      setDots((prevDots) => (prevDots.length < 3 ? prevDots + '.' : ''));
    }, 500); // A cada 500ms, um ponto é adicionado ou resetado

    return () => clearInterval(intervalId); // Limpa o intervalo ao desmontar
  }, []);

  return (
    <Backdrop
      open={true}
      sx={{
        zIndex: 1300,
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        textAlign: 'center',
        p: 3,
        color: 'white', // Fonte branca
      }}
    >
      <Box sx={{ width: '100%', maxWidth: 300, marginBottom: 3 }}>
        <Lottie
          options={{
            loop: true,
            autoplay: true,
            animationData: AIAnimation,
            rendererSettings: {
              preserveAspectRatio: 'xMidYMid slice',
            },
          }}
          height="100%"
          width="100%"
        />
      </Box>
      <Typography variant="h6">{`${title}${dots}`}</Typography>
      <Typography variant="subtitle1">{subtitle}</Typography>
    </Backdrop>
  );
};

export default AnimatedBackdrop;